import type { ComponentType } from "react";
import { Component } from "react";

import { noop } from "lodash";

import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";

interface StatefulDropdownProps {
    items: any[];
    selectedId?: string;
    onSelect?: any;
    onToggle?: any;
    disabled?: boolean;
    hasSearch?: boolean;
    DropDownButtonComponent?: ComponentType<any>;
    DropDownItemComponent?: ComponentType<any>;
    footerComponent?: ComponentType<any>;
    searchPlaceHolder?: string;
    title?: string;
    setRef?: any;
    width?: string | number;
    cssClassContainer?: string;
    selectedIds?: string;
    appendTo?: string;
}
export class StatefulDropdown extends Component<StatefulDropdownProps, { selectedId: string }> {
    static defaultProps = {
        disabled: false,
        DropDownButtonComponent: DropdownButton,
        DropDownItemComponent: SimpleDropdownItem,
        hasSearch: false,
        footerComponent: null,
        title: "",
        onToggle: noop,
    };

    public static getDerivedStateFromProps(props: StatefulDropdownProps, state: { selectedId: string }) {
        if (state.selectedId !== props.selectedId) {
            return {
                selectedId: props.selectedId ?? "",
            };
        }

        return null;
    }

    constructor(props: StatefulDropdownProps) {
        super(props);
        this.state = { selectedId: props.selectedId ?? "" };
    }

    public render() {
        const onSelect = (item: FixmeType) => {
            this.setState({ selectedId: item.id });
            this.props.onSelect(item);
        };

        const selectedItem = this.getSelectedItem(this.state.selectedId);
        const { DropDownButtonComponent, DropDownItemComponent, title, cssClassContainer } = this.props;

        const ButtonComponent = DropDownButtonComponent ?? DropdownButton;
        const content = [
            <ButtonComponent
                disabled={this.props.disabled}
                key={`${this.state.selectedId}BtnContainer`}
                hasValue={this.state.selectedId !== ""}
            >
                {selectedItem ? selectedItem.text : title}
            </ButtonComponent>,
            ...this.props.items,
        ];
        return (
            <Dropdown
                // @ts-expect-error Wrong type
                selectedIds={this.props.selectedIds ?? { [this.state.selectedId]: true }}
                onClick={onSelect}
                onToggle={this.props.onToggle}
                itemsComponent={DropDownItemComponent}
                disabled={this.props.disabled}
                hasSearch={this.props.hasSearch}
                searchPlaceHolder={this.props.searchPlaceHolder || undefined}
                footerComponent={this.props.footerComponent}
                ref={this.props.setRef}
                width={this.props.width}
                cssClassContainer={cssClassContainer}
                appendTo={this.props.appendTo}
            >
                {content}
            </Dropdown>
        );
    }

    private getSelectedItem = (selected: string | boolean | number) => {
        if (selected && typeof selected !== "string") {
            selected = selected.toString();
        }
        return this.props.items.find((item) => item.id === selected);
    };
}
